import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';



const ReportsSidebarV2 = ( { setReportType } ) => {
    const [ onExpanded, setOnExpanded ] = useState( true );
    const [ inExpanded, setInExpanded ] = useState( true );

    return (
        <Col className='pe-0' md={2} style={ { height: '100%' } }>
            <Row className='tf-section-container me-2' style={ { height: 'calc(100% - 15px)' } }>
                <Col className='p-0'>
                    <Accordion expanded={onExpanded}>
                        <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setOnExpanded( !onExpanded ) } />}>
                            <Row className='align-items-center w-100'>
                                <Col><Typography>On the Business</Typography></Col>
                            </Row>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ListGroup variant='flush'>
                                <ListGroup.Item className='border-0'>
                                    <Link to='#' onClick={ () => setReportType( 'summary' ) } style={ { textDecoration: 'none' } }>Summary</Link>
                                </ListGroup.Item>
                                <ListGroup.Item className='border-0'>
                                    <Link to='#' onClick={ () => setReportType( 'conversions' ) } style={ { textDecoration: 'none' } }>Conversions</Link>
                                </ListGroup.Item>
                            </ListGroup>
                        </AccordionDetails>
                    </Accordion>
                </Col>
            </Row>
        </Col>
    )
}

const mapProps = ( state ) =>( {
    // aid: state.user.aid,
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( ReportsSidebarV2 );